// extracted by mini-css-extract-plugin
module.exports = {"bigProductionTotal":"ProductionTotal_bigProductionTotal__NnLrv"};